import type { ListsFeedbackIssues } from '../model/interfaces'
import type { ListExperienceIssues, ListConnectionIssues } from '../model/types'

import { ExperienceIssues, ConnectionIssues } from '../model/enums'
import { FeedbackCategory, FeedbackRole, AdditionalPractice } from '../model/store/enums'

export const listExperienceIssues: ListExperienceIssues = {
  [ExperienceIssues.TooDifficultOrEasy]: 'Too difficult / too easy',
  [ExperienceIssues.StartedLateEndedEarly]: 'Started late/ended early',
  [ExperienceIssues.UnclearExplanations]: 'Unclear explanations',
  [ExperienceIssues.TooFast]: 'Too fast',
  [ExperienceIssues.NotEngaging]: 'Not engaging',
  [ExperienceIssues.NoProgress]: 'No progress',
  [ExperienceIssues.TutorNotSupportive]: 'Tutor not supportive',
  [ExperienceIssues.Other]: 'Other',
}

export const listConnectionIssues: ListConnectionIssues = {
  [ConnectionIssues.VideoAudioIssues]: 'Video/audio issues',
  [ConnectionIssues.FreezingOrLagging]: 'Freezing or lagging',
  [ConnectionIssues.EchoOrBackgroundNoise]: 'Echo or background noise',
  [ConnectionIssues.GotDisconnected]: 'Got disconnected',
  [ConnectionIssues.PlatformGlitchesOrErrors]: 'Platform glitches or errors',
  [ConnectionIssues.ScreenSharingIssues]: 'Screen sharing issues',
}

export const listFeedbackCategories: Record<FeedbackCategory, string> = {
  [FeedbackCategory.LearningExperience]: 'Learning Experience',
  [FeedbackCategory.Connection]: 'Connection',
}

export const listFeedbackRoles: Record<FeedbackRole, string> = {
  [FeedbackRole.Parent]: 'Parent',
  [FeedbackRole.Student]: 'Student',
}

export const listAdditionalPractice: Record<AdditionalPractice, string> = {
  [AdditionalPractice.Yes]: 'Yes',
  [AdditionalPractice.No]: 'No',
}

export const lists: ListsFeedbackIssues = {
  connectionIssues: listConnectionIssues,
  experienceIssues: listExperienceIssues,
}
